"use client";

export default function FooterLinks() {
  const linkSections = [
    {
      title: "Quick Links",
      links: [
        { label: "Equipment", href: "/equipment" },
        { label: "About", href: "/about" },
        { label: "Contact Us", href: "/contact" },
        { label: "Terms & Conditions", href: "/terms" },
        { label: "Privacy Policy", href: "/privacy" },
      ]
    }
  ];

  return (
    <div className="space-y-8">
      {linkSections.map((section) => (
        <div key={section.title} className="space-y-6">
          <h4 className="text-white text-lg font-bold font-body relative">
            {section.title}
            <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[var(--color-rr-green)]"></div>
          </h4>
          <ul className="space-y-3">
            {section.links.map((link) => (
              <li key={link.label}>
                <div
                  onClick={() => window.location.href = link.href}
                  className="text-gray-400 text-base hover:text-white hover:translate-x-1 transition-all duration-200 font-body inline-block cursor-pointer"
                >
                  {link.label}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}